module.exports = "<!-- Copyright (C) 2016 NooBaa -->\n\n    <svg-icon class=\"icon-small scale-on-hover\"\n        ko.tooltip=\"tooltip\"\n        ko.css=\"css\"\n        params=\"name: icon\"\n    ></svg-icon>\n";
